import "./AboutUsStyle.css";
import EventsData from "./EventsData";

function AboutUs(){
    return(
        <div className="about-container">
            <h1>Our History</h1>
            <p>Founded on April 17, 2023, the inauguration of Iyarkai Tamizhan Organization was honored by esteemed guests. K.S. Mokthiyar Ali, Chairman of Gingee town, graced the event as Chief Guest, alongside Dr. K. Rajalakshmi from the Government Hospital, Gingee, as a Special Guest. Their presence underscored our commitment to community engagement and environmental stewardship. With their support, we embark on a journey to foster environmental consciousness and sustainability in Tamil Nadu. Together, we strive to make a positive impact, nurturing our natural surroundings and building a greener, healthier future for all.</p>

            <h1>Organisation Members:</h1>

            <EventsData
                image="/assert/o1.jpeg"
                heading="K.S.M.MOKTHIYAR ALI MASTHAN"
                text=" GINGEE TOWN CHAIRMAN"/>

            <EventsData
                image="/assert/o2.jpeg"
                heading="DR.K.RAJALAKSHMI M.B.B.S.,DGO"
                text="Doctor, RAJAM HOSPITAL"/>                
            
            <EventsData
                image="/assert/o3.jpeg"
                heading="S.ARUN SENTHAMARAI"
                text=" FOUNDER OF IYARKAI TAMIZHAN ORGANISATION"/>

            <EventsData
                image="/assert/o4.jpeg"
                heading="B.SARATHI BALAMURUGAN"
                text=" CO - FOUNDER OF IYARKAI TAMIZHAN ORGANISATION"/>
        </div>
    )
}

export default AboutUs;